export default [
  ["2019-08-01", "30.6", "21.1"],
  ["2019-08-02", "28.9", "22.8"],
  ["2019-08-03", "30.0", "20.0"],
  ["2019-08-04", "30.6", "20.6"],
  ["2019-08-05", "27.8", "21.1"],
  ["2019-08-06", "26.1", "21.7"],
  ["2019-08-07", "28.9", "20.6"],
  ["2019-08-08", "28.9", "19.4"],
  ["2019-08-09", "28.3", "20.0"],
  ["2019-08-10", "27.2", "18.9"],
  ["2019-08-11", "26.7", "17.2"],
  ["2019-08-12", "29.4", "20.0"],
  ["2019-08-13", "26.1", "21.7"],
  ["2019-08-14", "28.9", "22.8"],
  ["2019-08-15", "29.4", "21.1"],
  ["2019-08-16", "26.1", "20.0"],
  ["2019-08-17", "30.6", "22.8"],
  ["2019-08-18", "32.2", "21.1"],
  ["2019-08-19", "32.2", "22.2"],
  ["2019-08-20", "31.1", "23.9"],
  ["2019-08-21", "30.6", "23.3"],
  ["2019-08-22", "32.2", "21.7"],
  ["2019-08-23", "23.3", "18.3"],
  ["2019-08-24", "24.4", "17.8"],
  ["2019-08-25", "25.0", "17.2"],
  ["2019-08-26", "23.3", "16.1"],
  ["2019-08-27", "23.9", "16.7"],
  ["2019-08-28", "23.3", "19.4"],
  ["2019-08-29", "27.2", "18.3"],
  ["2019-08-30", "30.0", "19.4"],
  ["2019-08-31", "27.2", "20.6"],
  ["2019-09-01", "25.6", "17.2"],
  ["2019-09-02", "23.3", "20.6"],
  ["2019-09-03", "27.8", "19.4"],
  ["2019-09-04", "30.6", "20.0"],
  ["2019-09-05", "23.3", "18.3"],
  ["2019-09-06", "19.4", "14.4"],
  ["2019-09-07", "23.9", "13.3"],
  ["2019-09-08", "25.0", "17.2"],
  ["2019-09-09", "25.6", "17.8"],
  ["2019-09-10", "24.4", "18.9"],
  ["2019-09-11", "31.1", "20.6"],
  ["2019-09-12", "27.2", "16.1"],
  ["2019-09-13", "22.2", "13.9"],
  ["2019-09-14", "23.3", "16.1"],
  ["2019-09-15", "27.8", "20.0"],
  ["2019-09-16", "25.0", "20.0"],
  ["2019-09-17", "24.4", "16.7"],
  ["2019-09-18", "20.6", "13.9"],
  ["2019-09-19", "21.1", "11.1"],
  ["2019-09-20", "25.6", "13.3"],
  ["2019-09-21", "28.9", "16.1"],
  ["2019-09-22", "30.0", "19.4"],
  ["2019-09-23", "31.7", "21.1"],
  ["2019-09-24", "24.4", "17.2"],
  ["2019-09-25", "26.1", "14.4"],
  ["2019-09-26", "28.3", "17.2"],
  ["2019-09-27", "24.4", "15.0"],
  ["2019-09-28", "27.8", "18.3"],
  ["2019-09-29", "26.7", "18.3"],
  ["2019-09-30", "21.7", "15.6"],
  ["2019-10-01", "27.2", "17.2"],
  ["2019-10-02", "33.9", "17.2"],
  ["2019-10-03", "17.2", "11.7"],
  ["2019-10-04", "18.9", "10.0"],
  ["2019-10-05", "16.1", "7.2"],
  ["2019-10-06", "21.1", "13.9"],
  ["2019-10-07", "26.1", "15.0"],
  ["2019-10-08", "17.8", "13.9"],
  ["2019-10-09", "15.0", "10.6"],
  ["2019-10-10", "21.7", "11.7"],
  ["2019-10-11", "17.8", "12.8"],
  ["2019-10-12", "19.4", "12.8"],
  ["2019-10-13", "19.4", "11.7"],
  ["2019-10-14", "22.2", "14.4"],
  ["2019-10-15", "17.8", "10.6"],
  ["2019-10-16", "18.9", "11.1"],
  ["2019-10-17", "13.9", "10.6"],
  ["2019-10-18", "14.4", "8.3"],
  ["2019-10-19", "15.6", "6.1"],
  ["2019-10-20", "15.0", "9.4"],
  ["2019-10-21", "19.4", "10.6"],
  ["2019-10-22", "17.2", "12.8"],
  ["2019-10-23", "18.3", "12.2"],
  ["2019-10-24", "19.4", "10.0"],
  ["2019-10-25", "18.3", "11.1"],
  ["2019-10-26", "17.2", "11.1"],
  ["2019-10-27", "19.4", "12.8"],
  ["2019-10-28", "17.2", "12.8"],
  ["2019-10-29", "15.0", "12.2"],
  ["2019-10-30", "17.2", "14.4"],
  ["2019-10-31", "21.7", "15.6"],
  ["2019-11-01", "21.7", "5.6"],
  ["2019-11-02", "11.7", "4.4"],
  ["2019-11-03", "12.2", "5.6"],
  ["2019-11-04", "13.3", "5.0"],
  ["2019-11-05", "16.1", "10.6"],
  ["2019-11-06", "12.2", "7.2"],
  ["2019-11-07", "13.9", "5.0"],
  ["2019-11-08", "5.0", "-1.7"],
  ["2019-11-09", "5.0", "-2.8"],
  ["2019-11-10", "10.6", "3.3"],
  ["2019-11-11", "16.7", "7.8"],
  ["2019-11-12", "13.9", "-3.9"],
  ["2019-11-13", "1.1", "-5.0"],
  ["2019-11-14", "7.2", "-2.2"],
  ["2019-11-15", "10.6", "2.8"],
  ["2019-11-16", "5.6", "-0.6"],
  ["2019-11-17", "6.1", "-1.1"],
  ["2019-11-18", "5.6", "2.8"],
  ["2019-11-19", "8.9", "4.4"],
  ["2019-11-20", "9.4", "4.4"],
  ["2019-11-21", "11.7", "3.9"],
  ["2019-11-22", "11.7", "3.3"],
  ["2019-11-23", "7.2", "1.1"],
  ["2019-11-24", "7.8", "4.4"],
  ["2019-11-25", "11.7", "3.9"],
  ["2019-11-26", "16.1", "6.7"],
  ["2019-11-27", "15.0", "9.4"],
  ["2019-11-28", "11.7", "2.8"],
  ["2019-11-29", "4.4", "-1.1"],
  ["2019-11-30", "6.1", "-0.6"],
  ["2019-12-01", "3.9", "-1.1"],
  ["2019-12-02", "2.8", "-0.6"],
  ["2019-12-03", "4.1", "0.5"],
  ["2019-12-04", "5.2", "-1.1"],
  ["2019-12-05", "10.4", "2.8"],
  ["2019-12-06", "13.2", "1.6"],
  ["2019-12-07", "8.1", "-0.5"],
  ["2019-12-08", "4.1", "-2.2"],
  ["2019-12-09", "7.0", "-1.3"],
  ["2019-12-10", "12.8", "-2.5"]
];
